import {TranslateService} from '@ngx-translate/core';
import xor from 'lodash-es/xor';

import {ChartUtils} from '../../+postpayroll/check/key-metrics/charts/chart.utils';
import {BasicLine} from '../../+postpayroll/check/key-metrics/charts/line/basic-line';
import {Chart} from '../../+postpayroll/check/key-metrics/key-metrics.interfaces';
import {LocalizationService} from '../../shared/localization/localization.service';
import {ChartBoxElement, DashboardBox, ResponseChartBox} from '../dashboard.interfaces';

import {DashboardChartUtils} from './dashboard-chart.utils';

export class AbsencesByFamilyChart extends BasicLine {

  constructor(chartBox: ResponseChartBox,
              translate: TranslateService,
              localization: LocalizationService,
              isAvg: boolean) {
    const params = chartBox.params;
    const chart: Chart = ChartUtils.getEmptyChart();

    Object.keys(params).forEach((key: string) => {
      if (!params[key].length) {
        chart.data.push({
          category: null,
          name: translate.instant(key),
          value: null
        });
      }

      params[key].forEach((element: ChartBoxElement) => {
        chart.data.push({
          category: translate.instant(element.name),
          name: translate.instant(key),
          value: element.value,
          metadata: element.link
        });
      });
    });
    chart.type = chartBox.cardType;

    super(chart, translate, localization, isAvg);

    this.xAxis[0].axisLabel = DashboardChartUtils.getAxisOptions();
    this.grid = DashboardChartUtils.getGridOptions();
    this.animation = true;

    DashboardChartUtils.setLinks(this.series, this.chart, this.categories);
    this.tooltip.position = DashboardChartUtils.getTooltipPositionFunc(<DashboardBox>chartBox);
    this.color = DashboardChartUtils.standardColors();
  }

  public sortCategories(array: string[]): string[] {
    const weeksArray = [
      this.translate.instant('Previous week'),
      this.translate.instant('Current week'),
      this.translate.instant('Next week')
    ];
    return xor(array, weeksArray).length === 0 ? weeksArray : array;
  }
}
